import { Controller } from '@hotwired/stimulus'

// A sheet whose last row (ui_row_button without a link) shows the rows and
// parts waiting hidden above or below it, and folds them away again. The
// button stays the last row and says what its click will do.
export default class extends Controller {
  static targets = ['button', 'label', 'more']

  toggle (event) {
    event.preventDefault()
    const open = this.buttonTarget.dataset.open !== 'true'
    this.moreTargets.forEach((element) => { element.hidden = !open })
    this.buttonTarget.dataset.open = String(open)
    if (this.hasLabelTarget) this.labelTarget.textContent = open ? this.buttonTarget.dataset.less : this.buttonTarget.dataset.more
  }
}
